import React from "react";

type Props = {
  className?: string;
};

const IconWarning = ({ className }: Props) => (
  <svg
    className={className}
    width="46"
    height="46"
    xmlns="http://www.w3.org/2000/svg"
  >
    <title>Warning</title>
    <g fill="none" fillRule="evenodd">
      <circle fill="#E2B93B" cx="23" cy="23" r="23" />
      <circle fill="#FFF" cx="23" cy="32" r="3" />
      <path
        d="M23 9a3 3 0 0 1 3 3v12a3 3 0 0 1-5.995.176L20 24V12l.005-.176A3 3 0 0 1 23 9Z"
        fill="#FFF"
      />
    </g>
  </svg>
);

export default IconWarning;
